"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.validateWalletOptions = void 0;
var joi_1 = __importDefault(require("joi"));
var onboard_common_1 = require("@sovryn/onboard-common");
var walletModule = joi_1["default"].object({
    label: joi_1["default"].string().required(),
    getIcon: joi_1["default"]["function"]().arity(0).required(),
    getInterface: joi_1["default"]["function"]().maxArity(1).required(),
    injectedNamespace: joi_1["default"].string().required(),
    checkProviderIdentity: joi_1["default"]["function"]().arity(1).required(),
    platforms: joi_1["default"].array().items(joi_1["default"].string())
});
var wallets = joi_1["default"].array().items(walletModule);
var filter = joi_1["default"].object().pattern(/\w+/, joi_1["default"].any().allow(joi_1["default"].boolean(), joi_1["default"].array().items(joi_1["default"].string())));
var walletOptions = joi_1["default"].object({
    custom: wallets,
    filter: filter
});
var validateWalletOptions = function (data) { return (0, onboard_common_1.validate)(walletOptions, data); };
exports.validateWalletOptions = validateWalletOptions;
